// extracted by mini-css-extract-plugin
export default {"input":"Dashboard_input__I-4BY","dashboard__multiSelectRoot":"Dashboard_dashboard__multiSelectRoot__FPXUu"};